import React, { Component } from 'react'
import { MasterLayout } from 'layout';
import DataTable from 'components/data-table';
import { header } from 'constants/table';
import { API_URL } from 'constants/config';
import { Input, DropDown, DatePicker } from 'components/tt-forms/common';
import { RowItemDSTongHopKHTTDonVi } from 'modules/thanh-tra-trung/datatable';
import { Link } from 'react-router';
import { ThanhTra } from 'api';
import { isEmpty, get } from 'lodash';
import moment from 'moment';
import { downloadExcel } from 'constants/downloadExcel';

export default class DanhSachTongHopKHTT extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tuNgay: '',
      denNgay: '',
      namThanhTra: '',
      dsNamTT: [],
      dataKeHoachThanhTra: [],
      dataListDonVi: [],
      selectListItem: [],
      listNamThanhTra: [],
      loaiHinhThanhTraList: [
        {
            giaTri: "THANH_TRA",
            ten: "Thanh tra"
        },
        {
            giaTri: "KIEM_TRA",
            ten: "Kiểm tra"
        }
      ]
    }
  }

  componentDidMount() {
    this.getKeHoachThanhTraList();
    this.getDonVi();
    this.getNamThanhTraList();
  }

  getNamThanhTraList() {
    ThanhTra.actions.getNamThanhTra.request().then(res => {
      if (!isEmpty(res.data)) {
        this.setState({
          listNamThanhTra: res.data
        });
      }
    });
  }

  handleChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  getKeHoachThanhTraList(isSearch) {
    let params = {
      page: isSearch ? 0 : this.state.pageData.number,
      size: isSearch ? 10 : this.state.pageData.size,
      isTatCaDonVi: true
    }

    if (this.state.loaiKeHoach) {
      params.loaiKeHoach = this.state.loaiKeHoach;
    }

    if (!isEmpty(this.state.selectListItem)) {
      const selectListItem = this.state.selectListItem || [];
      const arrDonVis = selectListItem.map(item => get(item, 'coQuanQuanLyId'));
      params.donViIds = arrDonVis.join(',');
    }

    if (this.state.tuNgay) {
      params.tuNgay = moment(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    if (this.state.denNgay) {
      params.denNgay = moment(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    if (!isEmpty(this.state.namThanhTra)) {
      params.namThanhTra = this.state.namThanhTra;
    }
    this.setState({
      tableLoading: true
    });
    ThanhTra.actions.getKeHoachThanhTra.request('', params).then(res => {
      if (!isEmpty(res.data._embedded)) {
        const dataKeHoachThanhTra = get(res, 'data._embedded.medial_KeHoachThanhTra_DanhSaches') || [];
        const pageData = get(res, 'data.page');
        const tableLoading = false;
        this.setState({
          dataKeHoachThanhTra,
          pageData,
          tableLoading
        });
      } else {
        const tableLoading = false;
        this.setState({
          dataKeHoachThanhTra: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading
        });
      }
    });
  }

  getDonVi() {
    ThanhTra.actions.getKHTTDonVi.request().then(res => {
      if (!isEmpty(res.data._embedded)) {
        const data = get(res, 'data._embedded.coQuanQuanLies');
        this.setState({
          dataListDonVi: data
        });
      } else {
        this.setState({
          dataListDonVi: []
        })
      }
    });
  }

  onChange(name, e) {
    if (name === 'donViThanhTra') {
      const { dataListDonVi } = this.state;
      const selectListItem = [...this.state.selectListItem];
      const checkItem = selectListItem.findIndex(item => Number(item.coQuanQuanLyId) === Number(e.target.value));
      if (checkItem === -1) {
        const selectItem = dataListDonVi.find(item => Number(item.coQuanQuanLyId) === Number(e.target.value));
        selectListItem.push(selectItem);
      }
      this.setState({
        selectListItem
      });
    } else {
      this.setState({
        [name]: e.target.value
      })
    }
  }

  handleExport() {}

  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: 0,
        size,
      }
    }, () => {
      this.getKeHoachThanhTraList();
    });
  }

  handlePageClick(page) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: page.selected
      }
    }, () => {
      this.getKeHoachThanhTraList();
    })
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  handleSearch(e) {
    e.preventDefault();
    this.getKeHoachThanhTraList(true);
  }

  removeDonVi(index) {
    const selectListItem = [...this.state.selectListItem];
    selectListItem.splice(index, 1)
    this.setState({
      selectListItem
    });
  }

  exportExcel() {
    const name = 'danh-sach-tong-hop-khtt-cua-cac-don-vi.xlsx';
    const apiUrl = 'keHoachThanhTras/export-excel'
    const donViIds = this.state.selectListItem.map(item => item.coQuanQuanLyId).join(',');
    const URL = `${String(API_URL)}/${apiUrl}?&tuNgay=` + (this.state.tuNgay ? moment(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '')
      + "&denNgay=" + (this.state.denNgay ? moment(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '')
      + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '')
      + "&donViIds=" + (donViIds ? donViIds : [])
      + "&isTatCaDonVi=true";

    downloadExcel(URL, name, true);
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container" ref="dskhtt">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-thanh-tra"></i>Danh sách tổng hợp KHTT/KHKT của các đơn vị</p>
            </div>
          </div>
          <div className="bottom-content">
            <div className='wrap-block pl15 pr15 pt20'>
              <form onSubmit={this.handleSearch.bind(this)}>
                <div className='row pl10 pr10'>
                  <div className='col-83 no-gutter'>
                    <DatePicker className="col-20" label='Quyết định ra từ ngày' bindValidator={this} channel="formTaoDon" onChange={this.handleChangeDate.bind(this, 'tuNgay')} value={this.state.tuNgay} name='tuNgay' />
                    <DatePicker className="col-20" label='Đến ngày' bindValidator={this} channel="formTaoDon" onChange={this.handleChangeDate.bind(this, 'denNgay')} value={this.state.denNgay} name='denNgay' />
                    <DropDown className="col-20 mb18" label="Năm thanh tra/kiểm tra" options={this.state.listNamThanhTra} keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, "namThanhTra")} placeholder />
                    <DropDown label="Loại hình thanh tra/kiểm tra" selectedValue={this.state.loaiKeHoach} placeholder className="col-25" onChange={this.handleChange.bind(this, 'loaiKeHoach')} name='loaiKeHoach'
                    options={this.state.loaiHinhThanhTraList} keyName="giaTri" valueName="ten"/>
                  </div>
                  <div className='col-16 mb0-18 search-thanh-tra'>
                    <button className='btn-green' >
                      <i className='tt-search'></i>Tìm kiếm
                    </button>
                  </div>
                  <div className='wrap-tt-dvph col-83 no-gutter'>
                    <DropDown className='col-20 mb18' label='Đơn vị' options={this.state.dataListDonVi} keyName="coQuanQuanLyId" valueName="ten" onChange={this.onChange.bind(this, 'donViThanhTra')} placeholder />
                    <div className='col-80 mb18'>
                      <div className='ds-tt-dvph'>
                        {
                          this.state.selectListItem.map((item, index) => {
                            return (
                              <div className='tt-dvph-item' key={index}>
                                <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, index)}>×</span>
                                <span className="tt-dvph-value">{item.ten}</span>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div className='row'>
                <span className="line-border"></span>
              </div>
            </div>
            {/* Ẩn xuất Excel */}
            <DataTable
              header={header.thanhTraTrung.DSTHKHTT}
              dataList={this.state.dataKeHoachThanhTra}
              exporttext="Xuất Excel"
              thanhTra={true}
              hideButtonExport={false}
              handleExport={this.exportExcel.bind(this)}
              pageData={this.state.pageData}
              parent={this}
              search
              tableLoading={this.state.tableLoading}>
              <RowItemDSTongHopKHTTDonVi />
            </DataTable>
          </div>
        </div>
      </MasterLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/DanhSachTongHopKHTT.jsx